import React, { ReactEventHandler, useEffect, useState } from 'react'
// @mui
import { alpha } from '@mui/material/styles'
import {
	Avatar, Typography, ListItemText, ListItemAvatar, MenuItem,
} from '@mui/material'
// utils
import usePfp from 'src/hooks/usePfp'
import getTokenName from 'src/utils/getTokenName'
import { PATH_DASHBOARD, PATH_PAGE } from 'src/routes/paths'
import { useNavigate } from 'react-router-dom'
import { fToNow } from '../../../utils/formatTime'
// _mock_
import { _contacts } from '../../../_mock'
// components
import Iconify from '../../../components/Iconify'
import Scrollbar from '../../../components/Scrollbar'
import MenuPopover from '../../../components/MenuPopover'
import BadgeStatus from '../../../components/BadgeStatus'
import { IconButtonAnimate } from '../../../components/animate'
import MyPfp from '../../../components/MyPfp'
import { useDispatch, useSelector } from '../../../redux/store'
import useAuth from '../../../hooks/useAuth'
import { getTokens, filterTokens } from '../../../redux/slices/token'
// ----------------------------------------------------------------------

const ITEM_HEIGHT = 64

// ----------------------------------------------------------------------

export default function ContactsPopover() {
	const [open, setOpen] = useState<HTMLElement | null>(null)

	const { tokens, changePrimaryPfp } = usePfp()

	const navigate = useNavigate()

	/* const { tokens: userTokens } = useAuth()

	const { tokens, sortBy, filters } = useSelector((state) => state.token)

	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getTokens(userTokens))
	}, [dispatch, userTokens]) */

	const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
		setOpen(event.currentTarget)
	}

	const handleClose = () => {
		setOpen(null)
	}

	const handleMenuSelect = (event: React.MouseEvent<HTMLElement>, id:string) => {
		changePrimaryPfp(id)
		setOpen(null)
		navigate(PATH_DASHBOARD.general.app, { replace: true })
	}

	return (
		<>
			<IconButtonAnimate
				color={open ? 'primary' : 'default'}
				onClick={handleOpen}
				sx={{
					width: 40,
					height: 40,
					...(open && {
						bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
					}),
				}}
			>
				{/* <Iconify icon="eva:people-fill" width={20} height={20} /> */}
				<MyPfp />
			</IconButtonAnimate>

			<MenuPopover
				open={Boolean(open)}
				anchorEl={open}
				onClose={handleClose}
				sx={{
					mt: 3.5,
					ml: -2.5,
					width: 320,
					'& .MuiMenuItem-root': {
						px: 1.5,
						height: ITEM_HEIGHT,
						borderRadius: 0.75,
					},
				}}
			>
				<Typography variant="h6" sx={{ p: 1.5 }}>
					My NFTs
					{' '}
					<Typography component="span">
						(
						{tokens.length}
						)
					</Typography>
				</Typography>

				<Scrollbar sx={{ height: ITEM_HEIGHT * 6 }}>
					{tokens.map((token) => (
						<MenuItem
							key={token.id}
							onClick={(event) => handleMenuSelect(event, token.id)}
						>
							<ListItemAvatar sx={{ position: 'relative' }}>
								<Avatar src={token.image} />
								{/* <BadgeStatus
									status={contact.status}
									sx={{ position: 'absolute', right: 1, bottom: 1 }}
								/> */}
							</ListItemAvatar>

							<ListItemText
								primaryTypographyProps={{ typography: 'subtitle2', mb: 0.25 }}
								secondaryTypographyProps={{ typography: 'caption' }}
								primary={getTokenName(token.tokenId, token._collectionName, token.name)}
								// secondary={contact.status === 'offline' && fToNow(contact.lastActivity)}
							/>
						</MenuItem>
					))}
				</Scrollbar>
			</MenuPopover>
		</>
	)
}
